import { useEffect, useState } from 'react';
import { Row, Col, Button, Form, Popconfirm, message, Table, Switch } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined } from "@ant-design/icons";
import axios from 'axios';
import { OrganizationGraph } from '@ant-design/graphs';


const Main = (
    {
        prefix = "",
        chartShow = true,
        treeData = [],
        processData = [],
        onChange = () => { },
        onSubmit = () => { },
        deleteNode = () => { },
        onSelect = () => { }
    }
) => {
    // const [selectedNode, setSelectedNode] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [treeTableData, setTreeTableData] = useState([]);
    // const [selectedKey, setSelectedKey] = useState([]);
    const [gData, setGData] = useState(treeData);
    const [languageKey, setLanguageKey] = useState("");
    // const [form] = Form.useForm();

    useEffect(() => {
        if (processData.length !== 0) {
            if (processData[0] === 1) {
                let method = processData[1];
                let childKey = processData[2];
                let name = processData[3];
                let classify_structure_id = processData[4];
                let newPermission_id = processData[5];
                let newType_id = processData[6];
                let responseData = processData[8];
                setGData(prev => {
                    return findParentIndex(method, prev, childKey, name, classify_structure_id, newPermission_id, newType_id, [], responseData);
                })
            }
            else if (processData[0] === 2) {
                let name = processData[1];
                let permission_id = processData[2];
                let classify_structure_type_id = processData[3];
                let classify_structure_type_parent_id = processData[4];
                let key = processData[5];
                let children = processData[6];
                let responseData = processData[7];

                setGData(prev => {
                    return [...prev, {
                        name: name,
                        permission_id: permission_id,
                        classify_structure_type_id: classify_structure_type_id,
                        classify_structure_type_parent_id: classify_structure_type_parent_id,
                        key: key,
                        children: children,
                        ...responseData
                    }];
                })
            }
            else if (processData[0] === 3) {
                let method = processData[1];
                let childKey = processData[2];
                let name = processData[3];
                let responseData = processData[7];
                setGData(prev => {
                    return findParentIndex(method, prev, childKey, name, null, null, null, [], responseData);
                })
            }
            else {
                let method = processData[1];
                let childKey = processData[2];
                setGData(prev => {
                    return findParentIndex(method, prev, childKey);
                })
            }
        }
    }, [processData]);
    useEffect(() => {
        setLanguageKey(prefix + "_language_data");
    }, [prefix]);
    useEffect(() => {
        setChartData(changDataStyle(gData))
        setTreeTableData(changToTreeTableData(gData))
    }, [gData]);
    useEffect(() => {
        setGData(treeData);
        onSelect(null)
    }, [treeData]);

    const columns = [
        {
            title: '名稱',
            dataIndex: 'name',
            key: 'name',
            render: (text, record, index) => (
                record[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "zh-tw")?.language_culture_value !== undefined
                    ? record[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "zh-tw").language_culture_value
                    : record.name
            )
        },
        {
            title: '英文名稱',
            dataIndex: 'nameEn',
            key: 'nameEn',
            render: (text, record, index) => (
                record[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "en")?.language_culture_value !== undefined
                    ? record[`${languageKey}`]?.find(tmp => tmp.language_culture_code === "en").language_culture_value
                    : record.name
            )
        },
        {
            title: '內/外部連結',
            dataIndex: 'pathCheck',
            key: 'pathCheck',
            render: (text, record, index) => (
                <></>
            )
        },
        // {
        //     title: '狀態',
        //     dataIndex: 'state',
        //     key: 'pathCheck',
        //     render: (text, record, index) => (
        //         <Switch checkedChildren="啟用" unCheckedChildren="停用" defaultChecked />
        //     )
        // },
        // {
        //     title: '上移/下移',
        //     dataIndex: 'state',
        //     key: 'pathCheck',
        //     render: (text, record, index) => (
        //         <>
        //             <Row gutter={[8, 8]} align={'middle'}>
        //                 <Col span={12}>
        //                     <Button type="primary"
        //                         style={{
        //                             backgroundColor: '#7895B2'
        //                         }}
        //                         size={"small"}
        //                         icon={<ArrowUpOutlined />}
        //                         onClick={{}}
        //                     >
        //                         上移
        //                     </Button>
        //                 </Col>
        //                 <Col span={12}>
        //                     <Button type="primary"
        //                         style={{
        //                             backgroundColor: '#AEBDCA'
        //                         }}
        //                         size={"small"}
        //                         icon={<ArrowDownOutlined />}
        //                         onClick={{}}
        //                     >
        //                         下移
        //                     </Button>
        //                 </Col>
        //             </Row>
        //         </>
        //     )
        // },
        {
            title: '操作',
            dataIndex: 'action',
            width: '40%',
            key: 'action',
            render: (text, record, index) => (
                <>
                    <Row gutter={[8, 8]} align={'middle'}>
                        <Col span={6}>
                            <Button type="primary"
                                size={"small"}
                                style={{ verticalAlign: 'middle', backgroundColor: "#2E3840" }}
                                onClick={(e) => onSubmit(prefix, languageKey, record)}
                            >
                                新增子項目
                            </Button>
                        </Col>
                        <Col span={6}>
                            {/* {console.log(record)} */}
                            <Button type="primary"
                                size={"small"}
                                style={{ verticalAlign: 'middle', backgroundColor: "#4E6E81" }}
                                onClick={(e) => {
                                    onChange(prefix, languageKey, record)
                                    console.log({ record })
                                }}
                            >
                                編輯
                            </Button>
                        </Col>
                        <Col span={6}>
                            <Popconfirm
                                placement="rightTop"
                                title={"是否刪除"}
                                description={""}
                                onConfirm={() => { deleteNode(record, record.classify_structure_type_id) }}
                                okText="確認"
                                cancelText="取消"
                            >
                                <Button type="primary" size={"small"} style={{ verticalAlign: 'middle', backgroundColor: "#FF6969" }}>
                                    刪除
                                </Button>
                            </Popconfirm>
                        </Col>
                        {
                            ((prefix === "department" || prefix === "role") || (prefix === "permission")) &&
                            <Col span={6}>
                                <Button type="primary"
                                    size={"small"}
                                    style={{ verticalAlign: 'middle', backgroundColor: "#E6E2C3", color: "black" }}
                                    onClick={(e) => {
                                        // onSelect(record)
                                        console.log(record)
                                        window.open(`/officialweb/admin/pageSetting/${record.name}`)
                                        // navigate(`/officialweb/admin/pageSetting/${record.permission_id}`)

                                    }}
                                >
                                    {prefix === "permission"
                                        ? "前往頁面編排"
                                        : (prefix === "department"
                                            ? "職位"
                                            : "人員"
                                        )
                                    }
                                </Button>
                            </Col>
                        }
                    </Row>
                </>
            )
        },
    ];

    //treeTable重組測試資料
    const changToTreeTableData = (treeData_) => {
        let treeData = [...treeData_]
        for (let i = 0; i < treeData_.length; i++) {
            const node = treeData[i];

            treeData = [...treeData.map((map_item, map_index) => {
                if (map_index === i) {
                    return {
                        ...map_item,
                        key: map_item.classify_structure_type_id
                    }
                }
                else {
                    return {
                        ...map_item,
                    };
                }
            })];
            if (node.children) {
                const data = changToTreeTableData(treeData[i]?.children);
                treeData = [...treeData.map((map_item, map_index) => {
                    if (map_index === i) {
                        return {
                            ...map_item,
                            children: data
                        }
                    }
                    else {
                        return {
                            ...map_item,
                        }
                    }
                })];
            }
        }
        return treeData;
    }

    //chart重組資料
    const changDataStyle = (treeData_) => {
        let treeData = [...treeData_]
        for (let i = 0; i < treeData_.length; i++) {
            const node = treeData[i];

            treeData = [...treeData.map((map_item, map_index) => {
                if (map_index === i) {
                    return {
                        ...map_item,
                        id: `${map_item.classify_structure_type_id}`,
                        value: {
                            name: `${map_item[`${languageKey}`]?.[0]?.language_culture_value !== undefined
                                ? map_item[`${languageKey}`]?.[0]?.language_culture_value
                                : map_item.name
                                }`
                        },
                    }
                }
                else {
                    return {
                        ...map_item,
                    };
                }
            })];
            if (node.children) {
                const data = changDataStyle(treeData[i]?.children);
                treeData = [...treeData.map((map_item, map_index) => {
                    if (map_index === i) {
                        return {
                            ...map_item,
                            children: data
                        }
                    }
                    else {
                        return {
                            ...map_item,
                        }
                    }
                })];
            }
        }
        return treeData;
    }
    //chart樣式
    const config = {
        nodeCfg: {
            style: (node) => {
                return node.id === '1148'
                    ? {
                        fill: '#235E68',
                        stroke: '#91d5ff',
                    }
                    : {};
            },
            label: {
                style: (node, group, type) => {
                    const styles = {
                        icon: {
                            width: 32,
                            height: 32,
                        },
                        title: {
                            fill: '#fff',
                        },
                        name: {
                            fill: '#fff',
                        },
                    };
                    return node.id === '1148' ? styles[type] : {};
                },
            },

        },
    };


    //找相同節點
    const findParentIndex = (method, treeData_, childKey, name, classify_structure_id, newPermission_id, newType_id, parentIndex = [], responseData = {}) => {
        let treeData = [...treeData_]
        for (let i = 0; i < treeData_.length; i++) {
            const node = treeData[i];
            if (node.classify_structure_type_id === childKey) {
                if (method === "delete") {
                    return [...treeData.filter((map_item, map_index) => {
                        if (map_index !== i) {
                            return true;
                        }
                    }
                    )]
                }
                else {
                    treeData = [...treeData.map((map_item, map_index) => {
                        if (map_index === i && method === "create") {
                            return {
                                ...map_item,
                                children: [
                                    ...(map_item.children || []),
                                    {
                                        name: name,
                                        key: [Date.now()],
                                        permission_id: newPermission_id,
                                        classify_structure_type_id: newType_id,
                                        classify_structure_type_parent_id: childKey,
                                        classify_structure_id: classify_structure_id,
                                        children: [],
                                        ...responseData
                                    }
                                ]
                            }
                        }
                        else if (map_index === i && method === "edit") {
                            let resultObject = {
                                ...map_item,
                                name: name
                            }
                            if (responseData.hasOwnProperty(languageKey)) {
                                resultObject[languageKey] = responseData[languageKey]
                            } else {
                                resultObject[languageKey] = [{ language_culture_value: name }]
                            }

                            return resultObject

                        } else {
                            return {
                                ...map_item,
                            };
                        }
                    })];
                }
            } else if (node.children) {
                const data = findParentIndex(method, node.children, childKey, name, classify_structure_id, newPermission_id, newType_id, parentIndex.concat([i]), responseData);
                treeData = [...treeData.map((map_item, map_index) => {
                    if (map_index === i) {
                        return {
                            ...map_item,
                            children: data
                        }
                    } else {
                        return {
                            ...map_item,
                        }
                    }
                })];
            }
        }
        return treeData;
    }

    return (<>
        <Row gutter={[8, 8]} align={'middle'}>
            <Col span={24}>
                <Button type="primary"
                    size={"small"}
                    style={{ justify: 'right', verticalAlign: 'middle', backgroundColor: "#227C70" }}
                    onClick={(e) => onSubmit(prefix, languageKey, {})}
                >
                    新增
                </Button>
            </Col>
            {treeTableData.length !== 0 &&
                <>
                    <Col span={24}>
                        <Table
                            columns={columns}
                            dataSource={treeTableData}
                            expandable={{ defaultExpandAllRows: true }}
                        />
                    </Col>
                </>
            }
            {chartData.length !== 0 && chartShow &&
                <Col span={24}>
                    {chartData.map((mapItem, mapIndex) => {
                        return (
                            <OrganizationGraph  {...config} data={mapItem} />
                        )
                    })}
                </Col >
            }
        </Row>
    </>)
}
export default Main;


const Demo = (

) => {

    const [departmentData, setDepartmentData] = useState([]);
    const [roleData, setRoleData] = useState([]);
    const [userData, setUserData] = useState([]);
    const [departmentProcessData, setDepartmentProcessData] = useState([]);
    const [roleProcessData, setRoleProcessData] = useState([]);
    const [departmentId, setDepartmentId] = useState(null);
    const [roleId, setRoleId] = useState(null);
    const [departmentName, setDepartmentName] = useState([]);
    const [roleName, setRoleName] = useState([]);
    const [targetKeys, setTargetKeys] = useState([]);
    const [modalShow, setModalShow] = useState(false);
    const [modalData, setModalData] = useState({
        edit: true,
        prefix: "department",
        languageKey: "department_language_data",
        node: [],
        data: { name: "" }
    });


    const [form] = Form.useForm();
    const onReset = () => {
        form.resetFields();
    };
    const cancelModal = () => {
        setModalData({
            edit: true,
            languageKey: "department_language_data",
            node: [],
            data: { name: "" }
        })
    }
    const addModal = (prefix, languageKey, node) => {

        setModalData((prev) => {
            return {
                edit: false,
                prefix: prefix,
                languageKey: languageKey,
                node: node,
                data: { name: "" }
            }
        })
        setModalShow(true)
    }

    const createNodeDepartment = (values, selectedNode) => {

        let url = `/organization_structure/api/department`;
        let classify_structure_type_id = 0;
        let hasParent = 0;

        if (selectedNode?.classify_structure_type_id) {
            classify_structure_type_id = selectedNode?.classify_structure_type_id
            hasParent = 1;
        } //有沒有selected

        let data = {
            "classify_structure_id": 9,
            "classify_structure_type_id": classify_structure_type_id,
            "name": values?.name,
            "department_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": values?.name
                }
            ]
        }
        createNode("department", values, selectedNode, url, data, hasParent)
    }
    const createNodeRole = (values, selectedNode) => {
        let url = `/organization_structure/api/role`;
        let classify_structure_type_id = 0;
        let hasParent = 0;

        if (selectedNode?.classify_structure_type_id) {
            classify_structure_type_id = selectedNode?.classify_structure_type_id
            hasParent = 1;

        } //有沒有selected

        let data = {
            "classify_structure_id": 8,
            "department_id": departmentId,
            "department_role_index": 1,
            "classify_structure_type_id": classify_structure_type_id,
            "name": values?.name,
            "role_language_data": [
                {
                    "language_culture_code": "zh-tw",
                    "language_culture_value": values?.name
                }
            ]
        }
        createNode("role", values, selectedNode, url, data, hasParent)
    }
    const createNode = (type, values, selectedNode, url, data, hasParent) => {
        if (hasParent) { //有沒有selected
            axios.post(url, data)
                .then(response => {
                    if (response?.data?.status === "success") {
                        message.success('新增成功');
                        if (type === "department") {
                            setDepartmentProcessData([1, "create", selectedNode?.classify_structure_type_id, values?.name, 9, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], [], response.data])
                        }
                        else {
                            setRoleProcessData([1, "create", selectedNode?.classify_structure_type_id, values?.name, 8, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], [], response.data])
                        }
                    }
                    else {
                        message.error('新增失敗');
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    setModalData({
                        edit: true,
                        prefix: "department",
                        languageKey: "department_language_data",
                        node: [],
                        data: { name: "" }
                    })
                })
        } else {
            axios.post(url, data)
                .then(response => {
                    if (response.data.status === "success") {
                        message.success('新增成功');
                        if (type === "department") {
                            setDepartmentProcessData([2, values.name, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], 0, [Date.now()], [], response.data])
                        }
                        else {
                            setRoleProcessData([2, values.name, response.data["classify_structure_type_id"], response.data["classify_structure_type_id"], 0, [Date.now()], [], response.data])
                        }
                    }
                    else {
                        message.error('新增失敗');
                    }
                })
                .catch((error) => {
                })
                .finally(() => {
                    setModalData({
                        edit: true,
                        prefix: "department",
                        languageKey: "department_language_data",
                        node: [],
                        data: { name: "" }
                    })
                })
        };
    }
    const editModal = (prefix, languageKey, node) => {
        let data = {
            "name": node[`${languageKey}`]?.[0]?.language_culture_value !== undefined
                ? node[`${languageKey}`]?.[0]?.language_culture_value
                : node.name

        }
        setModalData({
            edit: true,
            prefix: prefix,
            languageKey: languageKey,
            node: node,
            data: data
        })
        setModalShow(true)
    }

    //編輯節點名稱
    const editNodeDepartment = (node, newName) => {
        let url = `/organization_structure/api/department`;
        let data = [{
            "department_id": node?.department_id,
            "classify_structure_id": 9,
            "classify_structure_type_id": node?.classify_structure_type_id,
            "name": newName,
            "department_language_data": [
                {
                    "language_manage_id": node?.department_language_data[0]?.language_manage_id,
                    "language_culture_code": "zh-tw",
                    "language_culture_value": newName
                }
            ]
        }]
        editNode("department", url, data, node.classify_structure_type_id, newName)
    }
    const editNodeRole = (node, newName) => {
        let url = `/organization_structure/api/role`;
        let data = [{
            "role_id": node.role_id,
            "classify_structure_id": 8,
            "classify_structure_type_id": node.classify_structure_type_id,
            "name": newName,
            "role_language_data": [
                {
                    "language_manage_id": node?.role_language_data[0]?.language_manage_id,
                    "language_culture_code": "zh-tw",
                    "language_culture_value": newName
                }
            ]
        }]
        editNode("role", url, data, node.classify_structure_type_id, newName)
    }
    const editNode = (type, url, data, classify_structure_type_id, newName) => {
        axios.patch(url, data)
            .then(response => {
                if (response.data.status === "success") {
                    if (type === "department") {
                        setDepartmentProcessData([3, "edit", classify_structure_type_id, newName])
                        setDepartmentName(newName)
                    }
                    else {
                        setRoleProcessData([3, "edit", classify_structure_type_id, newName])
                        setRoleName(newName)
                    }
                    message.success('修改成功');
                }
                else {
                    message.error('修改失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {
                setModalData({
                    edit: true,
                    prefix: "role",
                    languageKey: "role_language_data",
                    node: [],
                    data: { name: "" }
                })
            })
    };
    const deleteDepartment = (node, classify_structure_type_id) => {
        let url = `/organization_structure/api/department`;
        let data = [{
            "department_id": node.department_id,
            "classify_structure_id": 9,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("department", url, data, classify_structure_type_id)

    }
    const deleteRole = (node, classify_structure_type_id) => {
        let url = `/organization_structure/api/role`;
        let data = [{
            "role_id": node.role_id,
            "classify_structure_id": 8,
            "classify_structure_type_id": classify_structure_type_id,
        }]
        deleteNode("role", url, data, classify_structure_type_id)
    }
    //刪除訊息、找刪除節點
    const deleteNode = (type, url, data, classify_structure_type_id) => {
        axios
            .delete(url, { data: data })
            .then(response => {
                if (response.data.status === "success") {
                    message.success('刪除成功');
                    if (type === "department") {
                        setDepartmentProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.department_id === departmentId) {
                            setDepartmentId(null)
                        }
                    }
                    else {
                        setRoleProcessData([4, "delete", classify_structure_type_id])
                        if (data?.[0]?.role_id === roleId) {
                            setRoleId(null)
                        }
                    }
                }
                else {
                    message.error('刪除失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {

            })
    };
    const getDepartmentId = (node) => {
        if (node) {
            setDepartmentId(node?.department_id)
            let name = node?.department_language_data[0].language_culture_value
            setDepartmentName(name !== undefined ? name : node?.name)
        }
        else {
            setDepartmentId(null)
        }
    }
    const getRoleId = (node) => {
        if (node) {
            setRoleId(node?.role_id)
            let name = node?.role_language_data[0].language_culture_value
            setRoleName(name !== undefined ? name : node?.name)
        }
        else {
            setRoleId(null)
        }
    }
    const onChange = (newTargetKeys, direction, moveKeys) => {
        setTargetKeys(newTargetKeys);
    };
    const postUserRole = (departmentId, roleId, userIdArray) => {
        let data = [{
            "department_id": departmentId,
            "role_id": roleId,
            "user_id": userIdArray,
        }]
        axios.post('/organization_structure/api/user_role', data)
            .then(response => {
                if (response.data.status === "success") {
                    message.success('儲存成功');
                }
                else {
                    message.error('儲存失敗');
                }
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    };
    useEffect(() => {
        if (userData) {
            axios.get('/organization_structure/api/user_role', {
                params: {
                    department_id: departmentId,
                    role_id: roleId
                }
            })
                .then(response => {
                    let newTargetKeys = []
                    newTargetKeys = response.data['data'].map((map_item, index) => (
                        map_item.user_id.toString()
                    ))
                    setTargetKeys(newTargetKeys)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [userData])

    useEffect(() => {
        setUserData([])
        if (roleId) {
            axios.get('/organization_structure/api/user')
                .then(response => {
                    let newUserData = []
                    newUserData = response.data['data'].map((map_item, index) => (
                        {
                            key: map_item.user_id.toString(),
                            title: `${map_item.staff_name}-${map_item.serial_name}`

                        }
                    ))
                    setUserData(newUserData)
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [roleId])

    useEffect(() => {
        setRoleId()
        setRoleData([])
        if (departmentId) {
            axios.get('/organization_structure/api/role', {
                params: {
                    classify_structure_id: 8,
                    department_id: departmentId,
                    classify_structure_type_id: 0
                }
            })
                .then(response => {
                    setRoleData(response.data['data'])
                })
                .catch((error) => {
                })
                .finally(() => {
                })
        }
    }, [departmentId])
    useEffect(() => {
        axios.get('/organization_structure/api/department', {
            params: {
                classify_structure_id: 9,
                classify_structure_type_id: 0
            }
        })
            .then(response => {
                setDepartmentData(response.data['data'])
            })
            .catch((error) => {
            })
            .finally(() => {
            })
    }, [])

    useEffect(() => {
    }, [targetKeys])

    // return (<>
    //     {/* {console.log(modalData.prefix )} */}
    //     {modalData.prefix === "department"
    //         ?
    //         <InformationModal
    //             title={"部門資訊"}
    //             edit={modalData.edit}
    //             value={modalData?.data}
    //             treeNode={modalData?.node}
    //             modalShow={modalShow}
    //             onSubmit={createNodeDepartment}
    //             onChange={editNodeDepartment}
    //             setModalShow={setModalShow}
    //             cancelModal={cancelModal}
    //         ></InformationModal>
    //         :
    //         <InformationModal
    //             title={"職稱資訊"}
    //             edit={modalData.edit}
    //             value={modalData.data}
    //             treeNode={modalData.node}
    //             modalShow={modalShow}
    //             onSubmit={createNodeRole}
    //             onChange={editNodeRole}
    //             setModalShow={setModalShow}
    //             cancelModal={cancelModal}
    //         ></InformationModal>
    //     }
    //     <Row gutter={[8, 8]} align={'top'}>
    //         <Col span={12}>
    //             <Card
    //                 title="部門管理"
    //             >
    //                 <ClassifyStructure
    //                     prefix="department"
    //                     chartShow={true}
    //                     treeData={departmentData}
    //                     onSubmit={addModal}
    //                     onChange={editModal}
    //                     processData={departmentProcessData}
    //                     deleteNode={deleteDepartment}
    //                     onSelect={getDepartmentId} />
    //             </Card>
    //         </Col>

    //         <Col span={12}>
    //             <Row gutter={[8, 8]} align={'top'}>
    //                 <Col span={24}>

    //                     {departmentId && (<>
    //                         <Card
    //                             title={`${departmentName} - 職稱管理`}
    //                         >
    //                             <ClassifyStructure
    //                                 prefix="role"
    //                                 chartShow={true}
    //                                 treeData={roleData}
    //                                 onSubmit={addModal}
    //                                 onChange={editModal}
    //                                 processData={roleProcessData}
    //                                 deleteNode={deleteRole}
    //                                 onSelect={getRoleId} />
    //                         </Card>
    //                     </>)}
    //                 </Col>

    //                 <Col span={24}>
    //                     {departmentId && roleId && (<>
    //                         <Card
    //                             title={`${roleName} - 人員管理`}
    //                         >
    //                             <Form
    //                                 name="basic"
    //                                 initialValues={{ remember: true }}
    //                                 autoComplete="off"
    //                                 layout="vertical"
    //                                 form={form}
    //                                 onFinish={(values) => {
    //                                     onReset()
    //                                     postUserRole(departmentId, roleId, targetKeys)
    //                                 }}
    //                             >
    //                                 <Row justify={"end"}>
    //                                     <Form.Item>
    //                                         <Button type="primary" htmlType="submit">
    //                                             儲存
    //                                         </Button>
    //                                     </Form.Item>
    //                                 </Row>
    //                                 <Form.Item>
    //                                     <Transfer
    //                                         dataSource={userData}
    //                                         targetKeys={targetKeys}
    //                                         onChange={onChange}
    //                                         render={(item) => item.title}
    //                                         showSearch={true}
    //                                         pagination
    //                                         listStyle={{
    //                                             height: 300,
    //                                         }}
    //                                     />
    //                                 </Form.Item>
    //                             </Form>
    //                         </Card>
    //                     </>
    //                     )}
    //                 </Col >
    //             </Row >
    //         </Col >
    //     </Row >
    // </>)

}    
